<template>
  <div class="main">
    <!-- ── Tabs（最頂層）── -->
    <ul class="nav nav-tabs nav-tabs-simple" style="margin-bottom: 0;">
      <li :class="{active: activeTab === 'list'}">
        <a href="javascript:;" @click="activeTab = 'list'">清單</a>
      </li>
      <li v-if="isAdmin('stay')" :class="{active: activeTab === 'openTime'}">
        <a href="javascript:;" @click="switchTab('openTime')">設定填寫時間</a>
      </li>
      <li :class="{active: activeTab === 'total'}">
        <a href="javascript:;" @click="switchTab('total')">學年度總分</a>
      </li>
    </ul>

    <!-- ══ 清單 Tab ══ -->
    <div v-if="activeTab === 'list'">
      <section class="panel panel-default" style="margin-bottom: 0px;">
        <header class="panel-heading" style="padding: 10px;">
          <div class="panel-actions" style="top: 7px;">
            <a href="#searchArea" data-toggle="collapse" class="panel-action panel-action-toggle"></a>
          </div>
          <h4 class="panel-title">查詢條件</h4>
        </header>
        <div id="searchArea" class="panel-collapse collapse in">
          <div class="panel-body">
            <div class="row form-group">
              <div class="col-md-12">
                <div class="col-md-3">
                  <label class="col-md-4">學年</label>
                  <div class="col-md-8">
                    <select v-model="query.schYear" class="form-control">
                      <option value="">--請選擇--</option>
                      <option v-for="(item, index) in schYearList" :key="index" :value="item">{{ item }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="col-md-4">學期</label>
                  <div class="col-md-8">
                    <select v-model="query.smtr" class="form-control">
                      <option value="">--請選擇--</option>
                      <option value="1">第一學期</option>
                      <option value="2">第二學期</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="col-md-4">類型</label>
                  <div class="col-md-8">
                    <select v-model="query.evaluateType" class="form-control">
                      <option value="">全部</option>
                      <option value="current">現任幹部</option>
                      <option value="reserve">儲備幹部</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-3">
                  <label class="col-md-4">學號</label>
                  <div class="col-md-8">
                    <input type="text" class="form-control" v-model="query.stuAccount" />
                  </div>
                </div>
              </div>
            </div>
            <div class="row form-group">
              <div class="col-md-12">
                <div class="col-md-3">
                  <label class="col-md-4">姓名</label>
                  <div class="col-md-8">
                    <input type="text" class="form-control" v-model="query.stuName" />
                  </div>
                </div>
                <div class="col-md-3">
                  <button type="button" class="btn btn-danger" @click="updateGrid(1)">查詢</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="panel">
        <div class="panel-body">
          <div class="row form-group" v-if="isAdmin('stay')">
            <div class="col-md-12 text-right">
              <button class="btn btn-default" @click="downloadImportTemplate">下載匯入範本</button>
              <label for="cadreScoreFile" style="margin-bottom: 0px;">
                <div style="display:none;">
                  <input type="file" id="cadreScoreFile" name="cadreScoreFile" accept=".xlsx,.xls" @change="importScores($event)" />
                </div>
                <a class="btn btn-danger">匯入分數</a>
              </label>
              <button class="btn btn-danger" @click="exportList">匯出清單</button>
            </div>
          </div>

          <table class="table table-no-more table-bordered table-striped mb-none">
            <thead>
              <tr>
                <th class="text-center">序號</th>
                <th class="text-center">學年</th>
                <th class="text-center">學期</th>
                <th class="text-center">職稱</th>
                <th class="text-center">學號</th>
                <th class="text-center">姓名</th>
                <th class="text-center">區域</th>
                <th class="text-center" v-if="isAdmin('stay')">請假次數</th>
                <th class="text-center" v-if="isAdmin('stay')">記點點數</th>
                <th class="text-center" v-if="isAdmin('stay')">組長</th>
                <th class="text-center" v-if="isAdmin('stay')">宿舍輔導人員</th>
                <th class="text-center" v-if="isAdmin('stay')">總分</th>
                <th class="text-center" v-if="isAdmin('stay')">扣分</th>
                <th class="text-center" v-if="isAdmin('stay')">最後總分</th>
                <th class="text-center" v-if="isAdmin('stay')">違規及銷點明細</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in rows" :key="index">
                <td class="text-center">{{ (page - 1) * pageSize + index + 1 }}</td>
                <td class="text-center">{{ item.schYear }}</td>
                <td class="text-center">{{ item.smtr }}</td>
                <td class="text-center">{{ item.evaluateType === 'current' ? '現任幹部' : '儲備幹部' }}</td>
                <td class="text-center">{{ item.stuAccount }}</td>
                <td class="text-center">
                  <a href="javascript:;" class="btn-link" @click="gotoDetail(item)">{{ item.stuName }}</a>
                </td>
                <td class="text-center">{{ item.mageArea }}</td>
                <td class="text-center" v-if="isAdmin('stay')">{{ item.leaveCount != null ? item.leaveCount : '--' }}</td>
                <td class="text-center" v-if="isAdmin('stay')">{{ item.levsPoints != null ? item.levsPoints : '--' }}</td>
                <td class="text-center" v-if="isAdmin('stay')">{{ item.leaderName || '--' }}</td>
                <td class="text-center" v-if="isAdmin('stay')">{{ item.tutorName || '--' }}</td>
                <td class="text-center" v-if="isAdmin('stay')">{{ item.totalScore != null ? item.totalScore : '--' }}</td>
                <td class="text-center" v-if="isAdmin('stay')"></td>
                <td class="text-center" v-if="isAdmin('stay')"></td>
                <td class="text-center" v-if="isAdmin('stay')">
                  <button class="btn btn-link" @click="openViolateModal(item)">明細</button>
                  <button class="btn btn-link" @click="openRollcallModal(item)">點名回報</button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="text-center">
            <pageControl v-bind:page="page" v-bind:total="totalPage"></pageControl>
          </div>
        </div>
      </section>
    </div>

    <!-- ══ 設定填寫時間 Tab ══ -->
    <div v-else-if="activeTab === 'openTime'">
      <section class="panel">
        <div class="panel-body">
          <h4>設定填寫時間</h4>
          <hr />

          <!-- 現任幹部 -->
          <div class="row">
            <div class="col-md-12"><strong>現任幹部</strong></div>
          </div>
          <div class="row form-group" style="margin-top: 10px;">
            <div class="col-md-12">
              <div class="col-md-2"><label>填寫學年度/學期：</label></div>
              <div class="col-md-2">
                <label>學年度</label>
                <select class="form-control" v-model="openForm.current.schYear" @change="loadOpenTimeForType('current')">
                  <option :value="null">請選擇</option>
                  <option v-for="(y, i) in schYearList" :key="i" :value="y">{{ y }}</option>
                </select>
              </div>
              <div class="col-md-2">
                <label>學　期</label>
                <select class="form-control" v-model="openForm.current.smtr" @change="loadOpenTimeForType('current')">
                  <option value="1">第一學期</option>
                  <option value="2">第二學期</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12">
              <div class="col-md-2"><label>填寫日期：</label></div>
              <div class="col-md-3">
                <label>開放日</label>
                <input type="datetime-local" class="form-control" v-model="openForm.current.openStart" />
              </div>
              <div class="col-md-3">
                <label>結束日</label>
                <input type="datetime-local" class="form-control" v-model="openForm.current.openEnd" />
              </div>
            </div>
          </div>

          <hr />

          <!-- 儲備幹部 -->
          <div class="row">
            <div class="col-md-12"><strong>儲備幹部</strong></div>
          </div>
          <div class="row form-group" style="margin-top: 10px;">
            <div class="col-md-12">
              <div class="col-md-2"><label>填寫學年度/學期：</label></div>
              <div class="col-md-2">
                <label>學年度</label>
                <select class="form-control" v-model="openForm.reserve.schYear" @change="loadOpenTimeForType('reserve')">
                  <option :value="null">請選擇</option>
                  <option v-for="(y, i) in schYearList" :key="i" :value="y">{{ y }}</option>
                </select>
              </div>
              <div class="col-md-2">
                <label>學　期</label>
                <select class="form-control" v-model="openForm.reserve.smtr" @change="loadOpenTimeForType('reserve')">
                  <option value="1">第一學期</option>
                  <option value="2">第二學期</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12">
              <div class="col-md-2"><label>填寫日期：</label></div>
              <div class="col-md-3">
                <label>開放日</label>
                <input type="datetime-local" class="form-control" v-model="openForm.reserve.openStart" />
              </div>
              <div class="col-md-3">
                <label>結束日</label>
                <input type="datetime-local" class="form-control" v-model="openForm.reserve.openEnd" />
              </div>
            </div>
          </div>

          <hr />
          <div class="row">
            <div class="col-md-12 text-center">
              <button class="btn btn-default" style="min-width: 120px; margin-right: 10px;" @click="cancelOpenTime">取消</button>
              <button class="btn btn-danger" style="min-width: 120px;" @click="saveOpenTime">儲存</button>
            </div>
          </div>
        </div>
      </section>
    </div>

    <!-- ══ 學年度總分 Tab ══ -->
    <div v-else-if="activeTab === 'total'">
      <section class="panel panel-default" style="margin-bottom: 0px;">
        <header class="panel-heading" style="padding: 10px;">
          <h4 class="panel-title">查詢條件</h4>
        </header>
        <div class="panel-body">
          <div class="row form-group">
            <div class="col-md-12">
              <div class="col-md-3">
                <label class="col-md-4">學年度</label>
                <div class="col-md-8">
                  <select v-model="totalQuery.schYear" class="form-control">
                    <option :value="null">--請選擇--</option>
                    <option v-for="(item, index) in schYearList" :key="index" :value="item">{{ item }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-3">
                <label class="col-md-4">學號</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" v-model="totalQuery.stuAccount" />
                </div>
              </div>
              <div class="col-md-3">
                <label class="col-md-4">姓名</label>
                <div class="col-md-8">
                  <input type="text" class="form-control" v-model="totalQuery.stuName" />
                </div>
              </div>
              <div class="col-md-3">
                <label class="col-md-4">職稱</label>
                <div class="col-md-8">
                  <select v-model="totalQuery.evaluateType" class="form-control">
                    <option value="">全部</option>
                    <option value="current">現任幹部</option>
                    <option value="reserve">儲備幹部</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12">
              <div class="col-md-3">
                <button type="button" class="btn btn-danger" @click="loadTotalList">查詢</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="panel">
        <div class="panel-body">
          <div class="table-responsive">
            <table class="table table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center">序號</th>
                  <th class="text-center">學年度</th>
                  <th class="text-center">學號</th>
                  <th class="text-center">姓名</th>
                  <th class="text-center">宿舍區域</th>
                  <th class="text-center">職稱</th>
                  <th class="text-center">第一學期考核成績</th>
                  <th class="text-center">第一學期總分</th>
                  <th class="text-center">第二學期考核成績</th>
                  <th class="text-center">第二學期面試成績</th>
                  <th class="text-center">第二學期總分</th>
                  <th class="text-center">學年度總分</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in totalData.rows" :key="index">
                  <td class="text-center">{{ index + 1 }}</td>
                  <td class="text-center">{{ item.schYear }}</td>
                  <td class="text-center">{{ item.stuAccount }}</td>
                  <td class="text-center">{{ item.stuName }}</td>
                  <td class="text-center">{{ item.mageArea }}</td>
                  <td class="text-center">{{ item.evaluateType === 'current' ? '現任幹部' : '儲備幹部' }}</td>
                  <td class="text-center">
                    <template v-if="item.smtr1Assess && item.smtr1Assess.length">
                      <div v-for="(r, ri) in item.smtr1Assess" :key="'s1a'+ri">{{ r.role }}：{{ r.score }}</div>
                    </template>
                    <span v-else>--</span>
                  </td>
                  <td class="text-center">{{ item.smtr1Total != null ? item.smtr1Total : '--' }}</td>
                  <td class="text-center">
                    <template v-if="item.smtr2Assess && item.smtr2Assess.length">
                      <div v-for="(r, ri) in item.smtr2Assess" :key="'s2a'+ri">{{ r.role }}：{{ r.score }}</div>
                    </template>
                    <span v-else>--</span>
                  </td>
                  <td class="text-center">
                    <template v-if="item.smtr2Interview && item.smtr2Interview.length">
                      <div v-for="(r, ri) in item.smtr2Interview" :key="'s2i'+ri">{{ r.role }}：{{ r.score }}</div>
                    </template>
                    <span v-else>--</span>
                  </td>
                  <td class="text-center">{{ item.smtr2Total != null ? item.smtr2Total : '--' }}</td>
                  <td class="text-center">{{ item.yearTotal != null ? item.yearTotal : '--' }}</td>
                </tr>
                <tr v-if="!totalData.rows || totalData.rows.length === 0">
                  <td colspan="12" class="text-center">無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </div>

    <!-- ══ 違規及銷點明細 Modal ══ -->
    <div v-if="showViolateModal" style="position:fixed;top:0;left:0;width:100%;height:100%;z-index:1050;overflow-y:auto;">
      <div style="position:relative;margin:30px auto;max-width:960px;background:#fff;border-radius:4px;box-shadow:0 5px 15px rgba(0,0,0,.5);">
        <div style="padding:15px;border-bottom:1px solid #e5e5e5;display:flex;justify-content:space-between;align-items:center;">
          <h4 style="margin:0;">違規及銷點明細</h4>
          <button type="button" style="background:none;border:none;font-size:20px;cursor:pointer;" @click="closeViolateModal">&times;</button>
        </div>
        <div style="padding:15px;">
          <div class="row form-group">
            <div class="col-md-4">
              <label>宿舍類別</label>
              <select class="form-control" v-model="violateDormTypeFilter">
                <option value="">全部</option>
                <option v-for="opt in dormTypeOptions" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
              </select>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center">宿舍類別</th>
                  <th class="text-center">學期</th>
                  <th class="text-center">學制</th>
                  <th class="text-center">系科年級</th>
                  <th class="text-center">學號</th>
                  <th class="text-center">姓名</th>
                  <th class="text-center">宿舍床位</th>
                  <th class="text-center">扣點概況</th>
                  <th class="text-center">(扣)點數</th>
                  <th class="text-center">違規日期</th>
                  <th class="text-center">登記日期</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in filteredViolateRows" :key="index">
                  <td class="text-center">{{ dormTypeLabel(item.dormitoryType) }}</td>
                  <td class="text-center">{{ item.smtr }}</td>
                  <td class="text-center">{{ item.deptSsymStr }}</td>
                  <td class="text-center">
                    <span v-if="item.deptCode">{{ item.deptCodeStr }}-{{ item.drade }}年{{ item.dradeClass }}班</span>
                  </td>
                  <td class="text-center">{{ item.account }}</td>
                  <td class="text-center">{{ item.name }}</td>
                  <td class="text-center">{{ [item.bedFloor, item.bedRoom, item.bed].filter(Boolean).join('-') }}</td>
                  <td class="text-center">{{ item.violateName }}</td>
                  <td class="text-center">{{ item.violatePoint != null ? item.violatePoint : '--' }}</td>
                  <td class="text-center">{{ customFormatter(item.violateDate, 'YYYY/MM/DD') }}</td>
                  <td class="text-center">{{ customFormatter(item.crDate, 'YYYY/MM/DD') }}</td>
                </tr>
                <tr v-if="filteredViolateRows.length === 0">
                  <td colspan="11" class="text-center">無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);z-index:-1;" @click="closeViolateModal"></div>
    </div>

    <!-- ══ 點名回報 Modal ══ -->
    <div v-if="showRollcallModal" style="position:fixed;top:0;left:0;width:100%;height:100%;z-index:1060;overflow-y:auto;">
      <div style="position:relative;margin:30px auto;max-width:760px;background:#fff;border-radius:4px;box-shadow:0 5px 15px rgba(0,0,0,.5);">
        <div style="padding:15px;border-bottom:1px solid #e5e5e5;display:flex;justify-content:space-between;align-items:center;">
          <h4 style="margin:0;">點名回報（簽到日期與點名日期不同日）</h4>
          <button type="button" style="background:none;border:none;font-size:20px;cursor:pointer;" @click="closeRollcallModal">&times;</button>
        </div>
        <div style="padding:15px;">
          <div style="margin-bottom:10px;">總筆數：{{ rollcallRows.length }}</div>
          <div class="table-responsive">
            <table class="table table-bordered table-striped mb-none">
              <thead>
                <tr>
                  <th class="text-center">學號</th>
                  <th class="text-center">姓名</th>
                  <th class="text-center">點名日期</th>
                  <th class="text-center">簽到時間</th>
                  <th class="text-center">簽到情形</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in rollcallRows" :key="index">
                  <td class="text-center">{{ item.stuAccount }}</td>
                  <td class="text-center">{{ item.stuName }}</td>
                  <td class="text-center">{{ customFormatter(item.rollcallDate, 'YYYY/MM/DD') }}</td>
                  <td class="text-center">{{ customFormatter(item.signDate, 'YYYY/MM/DD HH:mm') }}</td>
                  <td class="text-center">{{ item.rollcallStatusStr }}</td>
                </tr>
                <tr v-if="rollcallRows.length === 0">
                  <td colspan="5" class="text-center">無資料</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div style="position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.5);z-index:-1;" @click="closeRollcallModal"></div>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    return {
      activeTab: "list",
      page: 1,
      pageSize: 10,
      totalPage: 0,
      schYearList: [],
      rows: [],
      query: {
        schYear: "",
        smtr: "",
        evaluateType: "",
        stuAccount: "",
        stuName: ""
      },
      // 設定填寫時間
      openForm: {
        current: { schYear: null, smtr: "1", openStart: "", openEnd: "" },
        reserve: { schYear: null, smtr: "1", openStart: "", openEnd: "" }
      },
      originalOpenForm: null,
      // 學年度總分
      totalQuery: { schYear: null, evaluateType: "", stuAccount: "", stuName: "" },
      totalData: { rows: [] },
      // 違規 Modal
      showViolateModal: false,
      currentViolateItem: null,
      violateRows: [],
      violateDormTypeFilter: "",
      // 點名回報 Modal
      showRollcallModal: false,
      rollcallRows: [],
      // 宿舍類別（住宿類型）對照：N=一般宿舍、V=寒暑假宿舍、S=特殊原因宿舍
      dormTypeOptions: [
        { value: "N", label: "一般宿舍" },
        { value: "V", label: "寒暑假宿舍" },
        { value: "S", label: "特殊原因宿舍" }
      ]
    };
  },
  computed: {
    filteredViolateRows() {
      if (!this.violateDormTypeFilter) return this.violateRows;
      return this.violateRows.filter(r => r.dormitoryType === this.violateDormTypeFilter);
    }
  },
  mounted() {
    if (this.sessionData == null) {
      this.$router.replace({ path: "/" });
      return;
    }
    this.initPage();
  },
  methods: {
    initPage() {
      this.$axios.post("/api/CadreAssess/init", JSON.stringify({})).then(resp => {
        if (resp.data.status === "success") {
          this.schYearList = resp.data.data.schYearList || [];
          if (this.schYearList.length > 0) {
            this.query.schYear = String(this.schYearList[0]);
            this.openForm.current.schYear = this.schYearList[0];
            this.openForm.reserve.schYear = this.schYearList[0];
            this.totalQuery.schYear = this.schYearList[0];
          }
          if (resp.data.data.nowSmtr) {
            this.query.smtr = String(resp.data.data.nowSmtr);
          }
          this.updateGrid(1);
        }
      });
    },
    switchTab(tab) {
      this.activeTab = tab;
      if (tab === "openTime") {
        this.loadOpenTimeForType("current");
        this.loadOpenTimeForType("reserve");
      } else if (tab === "total" && this.totalQuery.schYear) {
        this.loadTotalList();
      }
    },
    updateGrid(page) {
      this.page = page;
      const payload = { page: this.page, pageSize: this.pageSize, model: this.query };
      this.$axios.post("/api/CadreAssess/list", JSON.stringify(payload)).then(resp => {
        if (resp.data.status === "success") {
          this.rows = resp.data.data.rows || [];
          this.totalPage = resp.data.data.total || 1;
        } else {
          bootbox.alert(resp.data.msg || "查詢失敗");
        }
      });
    },
    importScores(e) {
      if (!this.isAdmin("stay")) { bootbox.alert("無權限操作"); return; }
      if (!e.target.files || e.target.files.length === 0) return;
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append("file", file);
      this.$axios.post("/api/CadreAssess/importScores", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      }).then(resp => {
        bootbox.alert(resp.data.msg || (resp.data.status === "success" ? "匯入成功" : "匯入失敗"), () => {
          if (resp.data.status === "success") this.updateGrid(this.page);
        });
      });
      e.target.value = "";
    },
    downloadImportTemplate() {
      this.$http.get("/api/CadreAssess/importTemplate", { responseType: "arraybuffer" }).then(res => {
        this.download2File(res);
      });
    },
    loadOpenTimeForType(type) {
      const form = this.openForm[type];
      if (!form.schYear) return;
      this.$axios.post("/api/CadreAssess/openTime/list", JSON.stringify({
        schYear: form.schYear,
        smtr: form.smtr
      })).then(resp => {
        if (resp.data.status === "success") {
          const rows = resp.data.data || [];
          const found = rows.find(r => r.evaluateType === type);
          if (found) {
            this.openForm[type].openStart = found.openStart ? found.openStart.substring(0, 16) : "";
            this.openForm[type].openEnd = found.openEnd ? found.openEnd.substring(0, 16) : "";
          } else {
            this.openForm[type].openStart = "";
            this.openForm[type].openEnd = "";
          }
          this.originalOpenForm = JSON.parse(JSON.stringify(this.openForm));
        }
      });
    },
    cancelOpenTime() {
      if (this.originalOpenForm) {
        this.openForm = JSON.parse(JSON.stringify(this.originalOpenForm));
      }
    },
    saveOpenTime() {
      if (!this.isAdmin("stay")) { bootbox.alert("無權限操作"); return; }
      const typeLabel = { current: "現任幹部", reserve: "儲備幹部" };
      // 僅儲存有完整填寫開放日/結束日的類型；未填寫者略過，避免送出空字串導致後端 DateTime 綁定失敗（請求出錯）
      const saveOne = (type) => {
        const form = this.openForm[type];
        if (!form.openStart && !form.openEnd) {
          return Promise.resolve({ skipped: true });
        }
        if (!form.openStart || !form.openEnd) {
          return Promise.resolve({ data: { status: "error", msg: typeLabel[type] + "請完整填寫開放日與結束日" } });
        }
        return this.$axios.post("/api/CadreAssess/openTime/save", JSON.stringify({
          schYear: form.schYear,
          smtr: form.smtr,
          evaluateType: type,
          openStart: form.openStart,
          openEnd: form.openEnd,
          isEnabled: "Y"
        }));
      };
      Promise.all([saveOne("current"), saveOne("reserve")]).then(results => {
        const failed = results.find(r => r.data && r.data.status !== "success");
        if (failed) {
          bootbox.alert(failed.data.msg || "儲存失敗");
          return;
        }
        if (results.every(r => r.skipped)) {
          bootbox.alert("請至少填寫一組開放日與結束日");
          return;
        }
        bootbox.alert("儲存成功", () => {
          this.loadOpenTimeForType("current");
          this.loadOpenTimeForType("reserve");
        });
      });
    },
    loadTotalList() {
      if (!this.totalQuery.schYear) { bootbox.alert("請選擇學年度"); return; }
      this.$axios.post("/api/CadreAssess/totalList", JSON.stringify(this.totalQuery)).then(resp => {
        if (resp.data.status === "success") {
          this.totalData = resp.data.data || { rows: [] };
        } else {
          bootbox.alert(resp.data.msg || "查詢失敗");
        }
      });
    },
    gotoDetail(item) {
      this.gotoView("stay.cadreAssess.edit", item);
    },
    dormTypeLabel(type) {
      const opt = this.dormTypeOptions.find(o => o.value === type);
      return opt ? opt.label : (type || "");
    },
    openViolateModal(item) {
      this.currentViolateItem = item;
      this.violateRows = [];
      this.violateDormTypeFilter = "";
      this.showViolateModal = true;
      const smtrFull = String(item.schYear) + String(item.smtr);
      this.$axios.post("/api/Violate/violateRecordGrid", JSON.stringify({
        page: 1,
        pageSize: 999,
        model: { account: item.stuAccount, smtr: smtrFull }
      })).then(resp => {
        // /api/Violate/violateRecordGrid 的 ResponseModel 不會設定 status，
        // 與其他使用此 API 的頁面（deduct / revoke）一致，直接讀 data.rows。
        const data = resp.data && resp.data.data;
        this.violateRows = (data && data.rows) ? data.rows : [];
      });
    },
    closeViolateModal() {
      this.showViolateModal = false;
      this.currentViolateItem = null;
      this.violateRows = [];
    },
    openRollcallModal(item) {
      if (!item) return;
      this.rollcallRows = [];
      this.showRollcallModal = true;
      this.$axios.post("/api/CadreAssess/rollcallReport", JSON.stringify({
        schYear: item.schYear,
        smtr: String(item.smtr),
        stuAccount: item.stuAccount
      })).then(resp => {
        if (resp.data.status === "success") {
          this.rollcallRows = (resp.data.data && resp.data.data.rows) ? resp.data.data.rows : [];
        } else {
          bootbox.alert(resp.data.msg || "查詢失敗");
        }
      });
    },
    closeRollcallModal() {
      this.showRollcallModal = false;
      this.rollcallRows = [];
    },
    exportList() {
      this.$http.post("/api/CadreAssess/exportList", this.query, { responseType: "arraybuffer" }).then(res => {
        this.download2File(res);
      });
    }
  }
};
</script>
